// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserAccountItem} from './digital-user-account-item';

export const DigitalUserAccountDetails = t.struct({
    digitalUserAccountList: t.list(DigitalUserAccountItem),
    isDigitalUserAccountLoading: t.Boolean,
    errorMessage: t.String
}, {
    defaultProps: {
        digitalUserAccountList: [],
        isDigitalUserAccountLoading: true,
        errorMessage: ''
    },
    name: 'DigitalUserAccountDetails',
    strict: true
});
